import { mapUserToken } from "../../auth/user-token.model";
import { mapSelectableInput } from "../../dynamic-forms/inputs/selectable-input.model";
import { mapGridView } from "../../shared/grid/grid-menu/grid-views/grid-view.model";
import { mapGridViewsState } from "../../shared/grid/grid-menu/grid-views/grid-views-state.model";
import { mapMenuItems } from "../../shared/menu/menu-item.model";
import { IAutoMapper } from "./interfaces";
import { mapAnalyticsItems } from "./mappings/analytics-item.mappings";
import { mapBillingItems } from "./mappings/billing-item.mapping";
import { mapDropdownListItem } from "./mappings/dropdown-list-item.mappings";
import { mapListItems } from "./mappings/list-item.mappings";
import { mapLookupModel } from "./mappings/lookup-model-mappings";
import { mapNlpKeywordModel } from "./mappings/nlp-keyword.mapping";

export const createMappings = (automapper: IAutoMapper) => {
  mapAnalyticsItems(automapper);
  mapBillingItems(automapper);
  mapDropdownListItem(automapper);
  mapGridView(automapper);
  mapGridViewsState(automapper);
  mapListItems(automapper);
  mapLookupModel(automapper);
  mapMenuItems(automapper);
  mapNlpKeywordModel(automapper);
  mapSelectableInput(automapper);
  mapUserToken(automapper);
};
